import React from 'react';
import { getIn18Text } from 'api';
import { Button, Modal } from 'antd';
import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';
import './dialog.scss';
const Dialog = ({ isModalVisible, isPrompt, isCancel, title = getIn18Text('TISHI'), content = '', okText = getIn18Text('ZHIDAOLE'), onOk, onCancel, danger, okButtonProps, }) => {
    const onConfirm = () => {
        if (onOk) {
            onOk();
        }
    };
    const onClickCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };
    return (React.createElement("div", null,
        React.createElement(Modal, { wrapClassName: "u-dialog", visible: isModalVisible, centered: true, closable: false, width: "480px", bodyStyle: { padding: '24px 40px' }, footer: [
                isCancel ? (React.createElement(Button, { key: "cancel", className: "u-middle-btn", onClick: onClickCancel }, getIn18Text('QUXIAO'))) : (''),
                React.createElement(Button, Object.assign({}, okButtonProps, { key: "confirm", type: "primary", className: "u-middle-btn", onClick: onConfirm, danger: danger }), okText),
            ] },
            isPrompt ? (React.createElement("div", { className: "u-dialog-title" },
                React.createElement(InfoCircleFilled, { style: { color: '#386EE7', marginRight: '9px' } }),
                getIn18Text('TISHI'))) : (React.createElement("div", { className: "u-dialog-title" },
                React.createElement(InfoCircleFilled, { style: { color: '#F74F4F', marginRight: '9px' } }),
                title)),
            content ? React.createElement("div", { className: "u-dialog-content" }, content) : null)));
};
export default Dialog;
